import React from 'react';

const Feedback = () => {

    return(
        <div className="feedback">
            <div className="feedback-content" id="correct">
                <div className="feedback-text">Correct!</div> 
                <div className="icon">⭐</div>
            </div>
            <div className="feedback-content" id="incorrect">
                <div className="feedback-text">Incorrect...</div> 
                <div className="icon">❌</div>
            </div>   
        </div>
    );

};

export default Feedback;